import { Component, ViewChild, ElementRef, OnInit } from '@angular/core';
  
import jsPDF from 'jspdf';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
pdfMake.vfs = pdfFonts.pdfMake.vfs;
import htmlToPdfmake from 'html-to-pdfmake';

@Component({
  selector: 'kt-viewexamen',
  templateUrl: './viewexamen.component.html',
  styleUrls: ['./viewexamen.component.scss']
})
export class ViewexamenComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }
  title = 'htmltopdf';
  
  @ViewChild('pdfTable', { static: true }) pdfTable: ElementRef;
  
  public downloadAsPDF() {
    const doc = new jsPDF();
   
    const pdfTable = this.pdfTable.nativeElement;
   
    var html = htmlToPdfmake(pdfTable.innerHTML);
     
    const documentDefinition = { content: html };
    pdfMake.createPdf(documentDefinition).open(); 
     
  }
}
